<template>
    <div>
        <taskAnswerPc v-if="!mobile"/>
        <taskAnswerMobile v-else/>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import taskAnswerMobile from "@/components/task/task_answer/mobile/task_answer";
    import taskAnswerPc from "@/components/task/task_answer/pc/task_answer";

    export default {
        name: "answer",
        components: {
            taskAnswerMobile,
            taskAnswerPc
        },
        data() {
            return {};
        },
        created() {},
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
            }),
        },
        watch: {},
        methods: {},
    };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/task/task_answer.vue